module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-feature-icon-5526ec9b6029e25dd22882b724f5eae5.png";